'use strict';

var UserUtils = require('../UserUtils');
var ChatUtils = require('../ChatUtils');
var TeamUtils = require('../TeamUtils');
var FirebaseUtils = require('../FirebaseUtils');

var CreateTeam = {
  getSchema: function getSchema() {
    return {
      "definitions": {
        "team": {
          "type": "object",
          "properties": {
            "displayName": { "type": "string" },
            "onboardedFrom": { "type": "string" }
          },
          "required": ["displayName"]
        },
        "user": {
          "type": "object",
          "properties": {
            "id": { "type": "string" },
            "displayName": { "type": "string" },
            "country": { "type": "string" },
            "email": { "type": "string" }
          },
          "required": ["id", "displayName", "country"]
        },
        "userTeam": {
          "type": "object",
          "properties": {
            "role": { "type": "string", "default": "" }
          },
          "required": ["role"]
        },
        "onboarding": {
          "type": "object",
          "properties": {
            "fullName": { "type": "string" },
            "displayName": { "type": "string" }
          },
          "required": ["displayName", "fullName"]
        }
      },

      "properties": {
        "team": { "$ref": "#/definitions/team" },
        "user": { "$ref": "#/definitions/user" },
        "userTeam": { "$ref": "#/definitions/userTeam" },
        "onboarding": { "$ref": "#/definitions/onboarding" }
      },
      "required": ["team", "user", "userTeam"]
    };
  },

  execute: function execute(fbApp, body, timestamp, callback) {
    var updates = {};
    var dbRef = fbApp.database().ref();

    // Create team if
    body.team.id = dbRef.child('teams').push().key;

    // Create User for the first time
    if (body.onboarding) {
      UserUtils.createUser(updates, timestamp, {
        id: body.user.id,
        country: body.user.country,
        email: body.user.email,
        fullName: body.onboarding.fullName,
        displayName: body.onboarding.displayName,
        onboardingSource: body.team.onboardedFrom
      });
    }

    // Create the list of members to add to the rooms
    if (!body.invitees) {
      body.invitees = [];
    }
    var members = body.invitees.map(function (invitee) {
      return {
        userId: invitee.id,
        displayName: invitee.displayName,
        access: 'member'
      };
    });
    members.push({
      userId: body.user.id,
      displayName: body.user.displayName,
      access: 'member'
    });

    // Create the default rooms
    defaultRooms.forEach(function (_ref) {
      var title = _ref.title,
          type = _ref.type,
          welcomeMessage = _ref.welcomeMessage;

      var roomInfo = {
        id: dbRef.child('rooms').push().key,
        title: title + ' at ' + body.team.displayName,
        type: type
      };
      ChatUtils.createRoom(updates, timestamp, roomInfo, body.team);
      ChatUtils.addUsersToRoom(updates, timestamp, roomInfo, body.team, members);

      // Welcome message
      ChatUtils.sendTextMessage(updates, timestamp, roomInfo, {
        id: 'fibo-bot',
        displayName: 'Fibo'
      }, {
        id: dbRef.child('rooms/' + roomInfo.id + '/messages').push().key,
        text: welcomeMessage,
        muted: true
      });

      // Hello message on the General channel
      if (type === 'team_general' && body.helloMessage) {
        ChatUtils.sendTextMessage(updates, timestamp, roomInfo, body.user, {
          id: dbRef.child('rooms/' + roomInfo.id + '/messages').push().key,
          text: body.helloMessage
        });
      }
    });

    // Create the team
    TeamUtils.createTeam(updates, timestamp, body.team, body.user.id);

    // Add main user to the team
    TeamUtils.addUserToTeam(updates, timestamp, body.team, body.user, {
      role: body.userTeam.role,
      access: "admin"
    });

    // Add the rest of the users to the team
    body.invitees.forEach(function (invitee) {
      // Add this user to the team
      TeamUtils.addUserToTeam(updates, timestamp, body.team, invitee, {
        role: "",
        access: "invitee"
      });

      // Create the invite
      TeamUtils.createTeamInvite(updates, timestamp, body.team, {
        id: body.user.id,
        role: body.userTeam.role,
        displayName: body.user.displayName
      }, invitee);
    });

    // Save to firebase
    FirebaseUtils.saveToFirebase(dbRef, updates, callback);
  }
};

var welcomeMessageTemplate = 'Welcome\nFibo can help you stay in sync and connected with your work. Add your colleagues and try it out together.\n\n';
var defaultRooms = [{
  title: 'Random',
  type: 'team_random',
  welcomeMessage: 'This is a space for random topics that are fun and interesting to share but not necessarily about day to day work. This is a great place to get to know your teammates better.'
}, {
  title: 'General',
  type: 'team_general',
  welcomeMessage: welcomeMessageTemplate + 'Organize general conversation in this group. This is a great place for team wide discussion.'
}];

module.exports = CreateTeam;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/functions/CreateTeam.js
// module id = 1030
// module chunks = 0